import { useSnackbar } from "notistack";
import { createElement, useCallback } from "react";

function preserveNewlines(message: React.ReactNode): React.ReactNode {
  if (typeof message !== "string") {
    return message;
  }
  return createElement("span", { style: { whiteSpace: "pre-line" } }, message);
}

/**
 * Helper utility to show standard toasts
 */
export function useToast() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showSuccessToast = useCallback(
    (message: string) => {
      enqueueSnackbar({
        message,
        variant: "success",
      });
    },
    [enqueueSnackbar]
  );

  const showInfoToast = useCallback(
    (message: string) => {
      enqueueSnackbar({
        message,
        variant: "info",
      });
    },
    [enqueueSnackbar]
  );

  const showErrorToast = useCallback(
    (message: React.ReactNode) => {
      enqueueSnackbar({
        message: preserveNewlines(message),
        variant: "error",
      });
    },
    [enqueueSnackbar]
  );

  const showWarningToast = useCallback(
    (message: string) => {
      enqueueSnackbar({
        message,
        variant: "warning",
      });
    },
    [enqueueSnackbar]
  );

  return {
    showSuccessToast,
    showInfoToast,
    showErrorToast,
    showWarningToast,
    closeSnackbar,
  };
}
